import { Directive,Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDisableDir]'
})
export class DisableDirDirective {

  @Input() set appDisableDir( condition : boolean ) {

    const action = condition ? 'disable' : 'enable';
    if(this.ngControl?.control){
      this.ngControl.control[action]();
   }
  }

  constructor( private ngControl : NgControl ) {
  }

}